import { Injectable, signal } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class KeycloakInitStatusService {
    private readonly _failed = signal(false);

    readonly failed = this._failed.asReadonly();

    markFailed(): void {
        this._failed.set(true);
    }
}
